import React from 'react';
import { Text } from 'src/modules/shared/components/atoms/text';
import { CardSkeleton } from 'src/modules/shared/components/atoms/cards/card-skeleton';
import { ErrorState } from 'src/modules/shared/components/atoms/states/error-state';
import { useI18n } from 'src/modules/shared/hooks/provider-bounded/i18n';

/** Loading/error presentation for the connected-account section. */
interface ConnectedAccountsStateProps {
  /** Whether connected-account data is loading. */
  loading: boolean;
  /** The account-listing error to display, if any. */
  error: Error | null;
  /** Whether the connected-account section heading is visible. */
  showSectionTitles: boolean;
}

/** Presents the loading or failed state of an account-list request. */
export const ConnectedAccountsState: React.FC<ConnectedAccountsStateProps> = ({
  loading,
  error,
  showSectionTitles,
}) => {
  const { t } = useI18n();
  return (
    <div className="space-y-4">
      {showSectionTitles ? (
        <Text size="h6" weight="medium">
          {t('settings.integrations.whatsapp.accounts.title')}
        </Text>
      ) : null}

      {loading ? (
        <CardSkeleton
          header={{ avatar: true, title: true, subtitle: true }}
          content={{ lines: 4 }}
        />
      ) : (
        <ErrorState error={error?.message ?? ''} />
      )}
    </div>
  );
};
